/**
 * Risk-level → Tailwind class bundles for the Final Review checklist.
 *
 * All colors are sourced from the project's CSS-variable palette
 * (`--destructive`, `--warning`, `--poly-green`) so the risk-coloring
 * stays consistent with the rest of the app. No Tailwind default
 * palette (no `amber-*`) leaks in here.
 */

import type { RiskLevel } from '../types/contract-checker.types';

export interface RiskStyle {
  /** Tailwind class for the left-accent border on the clause card. */
  border: string;
  /** Background + foreground for the small uppercase risk chip. */
  chip: string;
  /** i18n key for the chip label (defaults provided by RISK_DEFAULTS). */
  chipLabelKey: string;
}

export const RISK_STYLES: Record<RiskLevel, RiskStyle> = {
  high: {
    border: 'border-l-destructive',
    chip: 'bg-destructive/10 text-destructive',
    chipLabelKey: 'ORGCONTRACTCHECKER_RESULT_RISK_HIGH',
  },
  medium: {
    border: 'border-l-[hsl(var(--warning))]',
    chip: 'bg-[hsl(var(--warning))/0.15] text-[hsl(var(--warning))]',
    chipLabelKey: 'ORGCONTRACTCHECKER_RESULT_RISK_MEDIUM',
  },
  low: {
    border: 'border-l-poly-green',
    chip: 'bg-poly-green/15 text-poly-green',
    chipLabelKey: 'ORGCONTRACTCHECKER_RESULT_RISK_LOW',
  },
};

/** English defaults for the risk chip labels — used as i18next
 *  `defaultValue` so UILM-missing keys don't break the UI. */
export const RISK_DEFAULTS: Record<RiskLevel, string> = {
  high: 'HIGH RISK',
  medium: 'MEDIUM RISK',
  low: 'LOW RISK',
};
